import { CheckboxGroup as CheckboxGroupPrimitive } from '@base-ui/react/checkbox-group';

import { cn } from '@/lib/utils';

export type CheckboxGroupProps = CheckboxGroupPrimitive.Props & {
  orientation?: 'vertical' | 'horizontal';
};

const CheckboxGroup = ({ className, orientation = 'vertical', ...props }: CheckboxGroupProps) => {
  return (
    <CheckboxGroupPrimitive
      data-slot="checkbox-group"
      className={cn('grid gap-2', { 'grid-flow-col': orientation === 'horizontal' }, className)}
      {...props}
    />
  );
};

export default CheckboxGroup;
